import { IBASE_URLS, IERROR_CODES, ISHOP_IDS } from "./types/common";

export const SHOP_ID = 11528;
export const SHOP_IDS: ISHOP_IDS = {
  "localhost:3000": 11528,
  "192.168.11.22:8091": 11528,
  "stada-sbb.payoo.com.vn": 23490,
  "stada-sb.payoo.com.vn": 11979,
  "stada-rl.payoo.com.vn": 12179,
  "stada.payoo.vn": 6694,
  "hoadon.stada.vn": 6629
};

export const BASE_URL = "192.168.11.22:8091";
export const BASE_URLS: IBASE_URLS = {
  "localhost:3000": "192.168.11.22:8091",
  "192.168.11.22:8091": "192.168.11.22:8091",
  "stada-sbb.payoo.com.vn": "minicollection-sbb.payoo.com.vn",
  "stada-sb.payoo.com.vn": "minicollection-sb.payoo.com.vn",
  "stada-rl.payoo.com.vn": "minicollection-rl.payoo.com.vn",
  "stada.payoo.vn": "minicollection.payoo.com.vn",
  "hoadon.stada.vn": "minicollection.payoo.com.vn",
}

// export const RESPONSE_ERROR_CODES = [
//   1001, // Yêu cầu không hợp lệ
//   1002, // Có lỗi xử lý, xin vui lòng thực hiện lại sau
//   1009, // Bạn chưa được cấp quyền sử dụng chức năng này
// ];

export const PAYMENT_EXPIRED = "PAYMENT_EXPIRED";  // Hủy – Hết hạn thanh toán
export const PAYMENT_FAILURE = "PAYMENT_FAILURE";  // Thất bại – Thanh toán lại
export const ERROR_CODES: IERROR_CODES = {
  599: PAYMENT_EXPIRED, // User cancels transaction
  533: PAYMENT_EXPIRED, // Payment orders expire after receiving successful results from bank
  801: PAYMENT_FAILURE, // Pending transaction
  500: PAYMENT_FAILURE, // Bank returns system error
  501: PAYMENT_FAILURE, // Bank declined payment
  503: PAYMENT_FAILURE, // Merchant Not Exist
  505: PAYMENT_FAILURE, // Pay amount is less than or greater than the limit
  507: PAYMENT_FAILURE, // Unspecified Failure
  508: PAYMENT_FAILURE, // Wrong card number
  509: PAYMENT_FAILURE, // Wrong card holder name
  511: PAYMENT_FAILURE, // Card is not registered for ecommerce transaction
  512: PAYMENT_FAILURE, // Wrong issue / Expired date
  513: PAYMENT_FAILURE, // Exist Amount
  521: PAYMENT_FAILURE, // Not enough money in account bank
  522: PAYMENT_FAILURE, // Account is invalid
  523: PAYMENT_FAILURE, // Account is locked
  524: PAYMENT_FAILURE, // Card information is invalid
  525: PAYMENT_FAILURE, // OTP is wrong or expired
  526: PAYMENT_FAILURE, // Card is locked
  527: PAYMENT_FAILURE, // Pay amount is greater than the maximum
  528: PAYMENT_FAILURE, // Pay amount is less than the minimum
  529: PAYMENT_FAILURE, // Exceed to the maximum top up amount for one day
  530: PAYMENT_FAILURE, // Exceed to the maximum top up number for one day
  531: PAYMENT_FAILURE, // Cannot connect to Bank system
  532: PAYMENT_FAILURE, // Bank system maintenance
  534: PAYMENT_FAILURE, // Linked account is invalid
  535: PAYMENT_FAILURE, // Card is expired
  536: PAYMENT_FAILURE, // Wrong info relating bank account
  537: PAYMENT_FAILURE, // Declined payment. Transaction need refunding
  538: PAYMENT_FAILURE, // Request OTP
  539: PAYMENT_FAILURE, // Order payment time is expired
  597: PAYMENT_FAILURE, // System error
  598: PAYMENT_FAILURE, // Unknown return code
  755: PAYMENT_FAILURE, // Invalid parameters
  800: PAYMENT_FAILURE, // Not yet receive final result from bank
}